import React from 'react';
import BaseClass from '@/pages/BaseClass';

export default class Foot extends BaseClass {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {

    }

    render() {
        return (
            <>
                <div className="foot">
                    <div><img src={require('@/assets/images/logo_foot.png')}/></div>
                    <div><a href="https://beian.miit.gov.cn/" target="_blank">苏ICP备2023018591号-1</a></div>
                    <div><span>Copyright © 2026 创新工坊</span></div>
                </div>
            </>
        );
    }
}


